import "./HelloIssues.scss";

import PostWrapper from "../PostWrapper";
import { PostCategory } from "../PostsHome";

function HelloIssuesScreen() {
  return (
    <PostWrapper
      category={PostCategory.HowTo}
      subTitle="Setting up OpenAI Codex in github via issues"
      title="Hello issues!"
    >
      <p>
        This POC was originally going to work off of github actions, but it
        turns out that costs money in addition to the montly plan 🙀
      </p>
      <p>
        In talking with codex (within the desktop app) I found out that we can
        use "Automations" to do a very similar flow, still using the github
        issue as the starting point. There's obviously more manual interaction
        in this flow, but it still feels pretty cool (and the cost is right) 😅
      </p>
      <p>
        You can see the issue that triggered this local branch to be made here:{" "}
        <a
          href="https://github.com/lrcrews/ryancrews.com.react/issues/3"
          target="_blank"
          rel="noreferrer"
        >
          GitHub Issue #3
        </a>
      </p>
      <p>
        To make it work I created a couple of labels in github, "Ready for dev"
        and "codex-local-started", and provided this prompt to codex to set up
        the automation:
      </p>
      <pre className="prompt">
        Create a recurring automation for
        /Users/ryan/projects/react/ryancrews.com.react that checks GitHub issues
        in lrcrews/ryancrews.com.react for open issues labeled `Ready for dev`
        that do not have `codex-local-started` or `codex-tagged`. When one is
        found, add the `codex-local-started` label to the issue, create a local
        branch named `codex/issue-&lt;issue-number&gt;`, implement the requested
        change following AGENTS.md, and run the relevant verification commands
        from the repo instructions: `npm test -- --watchAll=false` and `npm run
        build` when feasible. Do not commit, push, or open a PR automatically.
        Leave the changes on the local branch and report: - issue number and
        title - branch name - files changed - verification performed - any
        failures, risks, or follow-ups If no matching issues are found, do
        nothing except report that there was no eligible issue.
      </pre>
      <p>Pretty cool for a first pass at this kind of thing.</p>
      <h3>Everything written below was generated by OpenAI Codex</h3>
      <p>
        This is the third test of driving site updates from a GitHub issue
        instead of starting from a local note or a half-finished draft.
      </p>
      <p>
        The interesting bit is not just that a page gets created. It is that the
        request, status, implementation, and verification all live in one place
        that is already part of a normal development workflow.
      </p>
      <div className="hello-issues-flow">
        <div className="hello-issues-flow-step">
          <div className="label">1</div>
          <h3>Write the issue</h3>
          <p>Describe the content or change as a normal GitHub issue.</p>
        </div>
        <div className="hello-issues-flow-arrow">↓</div>
        <div className="hello-issues-flow-step">
          <div className="label">2</div>
          <h3>Mark it ready</h3>
          <p>Add the `Ready for dev` label so the automation can pick it up.</p>
        </div>
        <div className="hello-issues-flow-arrow">↓</div>
        <div className="hello-issues-flow-step">
          <div className="label">3</div>
          <h3>Start locally</h3>
          <p>
            Codex claims the issue, creates a branch, and keeps the diff
            focused.
          </p>
        </div>
        <div className="hello-issues-flow-arrow">↓</div>
        <div className="hello-issues-flow-step">
          <div className="label">4</div>
          <h3>Verify the work</h3>
          <p>Tests and build checks run before the change is handed back.</p>
        </div>
      </div>
      <h2>Why this flow is useful</h2>
      <p>
        A GitHub issue is a good handoff artifact because it captures intent
        without forcing the solution too early. Labels provide lightweight
        state, and the branch name makes it obvious which issue the local work
        belongs to.
      </p>
      <p>
        It also keeps the boring parts boring: pick an issue, make the change,
        run verification, and leave the branch ready for the next step.
      </p>
    </PostWrapper>
  );
}

export default HelloIssuesScreen;
